// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XN7F","right":"styles_right__pKt5q"};